import * as React from "react";
import IFramePortal from "./IFramePortal";

class FluidFrameContent extends React.Component<any, {}> {
  el: HTMLDivElement;
  w: number;
  h: number;

  componentDidMount() {
    this.handleResize();
  }

  componentDidUpdate() {
    this.handleResize();
  }

  handleResize() {
    if (this.w !== this.el.scrollWidth || this.h !== this.el.offsetHeight) {
      this.w = this.el.scrollWidth;
      this.h = this.el.offsetHeight;
      this.props.onSizeCalculated(this.w, this.h);
    }
  }

  render() {
    return (
      <div
        ref={el => (this.el = el)}
        style={{
          display: "inline-block"
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

/**
 * Use this component if you want to embed fluid content within
 * an iframe and have the iframe sized automatically.
 */

class FluidFrame extends React.Component<any, {}> {
  state = {
    width: 0,
    height: 0
  };

  onSizeCalculated = (width: number, height: number) => {
    this.setState({ width, height });
  };

  render() {
    let { style, ...rest } = this.props;

    style = {
      ...style,
      width: this.state.width,
      height: this.state.height,
      border: "none",
      overflow: "hidden"
    };

    return (
      <IFramePortal style={style} {...rest}>
        <FluidFrameContent onSizeCalculated={this.onSizeCalculated}>
          {this.props.children}
        </FluidFrameContent>
      </IFramePortal>
    );
  }
}

export default FluidFrame;
